import { Enum } from '@utils/enum';

export const redirectCodes = Enum(301, 302, 303, 307, 308);

type RedirectCode = keyof typeof redirectCodes;

export const isRedirectCode = (code: number): code is RedirectCode =>
  code in redirectCodes;
